const BuyingTime = () => (
    <section id="buying-time">
        <div className="container-fluid py-5 text-center gg-bg-gradient-rb-h text-white">
            <div className="row align-items-center justify-content-center">
                <div className="col-md-8 col-11">
                    <h3 className="mb-4 fw-bold">You’re not buying “more bottles.”</h3>
                    <h3 className="mb-5 fw-bold">
                        <span className="text-uppercase">You’re buying time.</span><br />
                        Time to fully reset.<br />
                        Time to finally break free.
                    </h3>
                    <a href="https://buygoods.com/secure/upsell/?account_id=11273&product_codename=glu3d&redirect=aHR0cHM6Ly9nbHVjb2dlbjE3LmNvbS9iZy91ZC9vcHRpdmlzdGEtdQ==" className="text-decoration-none btn gg-button-buy-yellow gg-bigger-button fw-bold text-uppercase gtm-nav-btn" data-gtm-label="GlucoGen Downsell 3 - Buy Time - Go To Offer">YES! I WANT TO BREAK FREE</a>
                </div>
            </div>
        </div>
    </section>
);

export default BuyingTime;